var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-layout"},[_c('z-page-transition',{attrs:{"type":"fade"}},[_c('router-view')],1),_c('img',{staticClass:"powered-by",attrs:{"src":require("@/assets/images/poweredby_dark.svg"),"alt":"Powered by Zoox"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }